export default __webpack_public_path__ + "static/media/close-icon.02e5432d.jpeg";